<template>
  <header class="p-3">
    <div class="header-area">
      <router-link to="/" class="d-flex align-items-center mb-2 mb-md-0 text-white text-decoration-none col-6 col-md-auto">
        <img :src="Logo" width="100" />
      </router-link>
      <nav class="navbar navbar-light p-0">
        <div class="d-flex col-12 col-md-3 col-lg-2 flex-wrap flex-md-nowrap justify-content-between">
            <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
              </svg>
            </button>
        </div>
      </nav>

      <ul class="nav col-6 col-md-auto ms-md-auto me-md-3 ms-md-auto justify-content-end">
        <li><router-link to="/" class="nav-link px-2">HOME</router-link></li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
            メニュー
          </a>
          <ul class="dropdown-menu">
            <li><router-link class="dropdown-item" to="/static/entry">新規登録方法のご案内</router-link></li>
            <li><router-link class="dropdown-item" to="/static/confirmation">シーズンプログラム予約前確認事項</router-link></li>
            <li><router-link class="dropdown-item" to="/static/cancel">シーズンプログラムキャンセル規定</router-link></li>
            <li><router-link class="dropdown-item" to="/static/annual-confirmation">通年プログラム予約前確認事項</router-link></li>
            <li><router-link class="dropdown-item" to="/static/annual-cancel">通年プログラムキャンセル規定</router-link></li>
            <li><router-link class="dropdown-item" to="/static/faq">よくあるご質問</router-link></li>
            <li><router-link class="dropdown-item" to="/inquiry/index">お問い合わせ</router-link></li>
            <li><router-link class="dropdown-item" to="/static/friendshipfund">フレンドシップファンドのご案内</router-link></li>
            <li><a class="dropdown-item" target="_blank" href="https://tokyo.ymca.or.jp/">東京YMCAホームページ</a></li>
          </ul>
        </li>
        <li><router-link to="/search/index" class="nav-link px-2">検索</router-link></li>
      </ul>

      <div class="header-btn-area col-auto ms-auto ms-md-0">
        <router-link to="/login/index" class="btn btn-header login"><i class="bi bi-box-arrow-in-right"></i>ログイン</router-link>
        <router-link to="/entry/index"  class="btn btn-header"><i class="bi bi-person"></i>メンバー登録</router-link>
      </div>
    </div>
  </header>
  <nav id="sidebar" class="mypage-contents_menu col-12 sidebar collapse">
    <div class="position-sticky pt-md-2">
      <ul class="nav">
        <li class="nav-item">
          <router-link to="/" class="nav-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
            </svg>
            <span class="ml-2">HOME</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/search/index" class="nav-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
            <span class="ml-2">検索</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/login/index" class="nav-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"/>
              <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
            </svg>
            <span class="ml-2">ログイン</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/entry/index" class="nav-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person-plus" viewBox="0 0 16 16">
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
            </svg>
            <span class="ml-2">メンバー登録</span>
          </router-link>
        </li>
      </ul>
      <router-link class="nav-link" to="/static/entry">新規登録方法のご案内</router-link>
      <router-link class="nav-link" to="/static/confirmation">シーズンプログラム予約前確認事項</router-link>
      <router-link class="nav-link" to="/static/cancel">シーズンプログラムキャンセル規定</router-link>
      <router-link class="nav-link" to="/static/annual-confirmation">通年プログラム予約前確認事項</router-link>
      <router-link class="nav-link" to="/static/annual-cancel">通年プログラムキャンセル規定</router-link>
      <router-link class="nav-link" to="/static/faq">よくあるご質問</router-link>
      <router-link class="nav-link" to="/inquiry/index">お問い合わせ</router-link>
      <router-link class="nav-link" to="/static/friendshipfund">フレンドシップファンドのご案内</router-link>
      <a class="nav-link" target="_blank" href="https://tokyo.ymca.or.jp/">東京YMCAホームページ</a>
    </div>
  </nav>
</template>


<script setup lang="ts"> 
import Logo from '@/images/logo.svg'

</script>